import { render, staticRenderFns } from "./ALPageHeader.vue?vue&type=template&id=204863fe&"
import script from "./ALPageHeader.vue?vue&type=script&lang=ts&"
export * from "./ALPageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ALPageHeader.vue?vue&type=style&index=0&id=204863fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports